/**
 * Parse a string as a float, or return null if it cannot be parsed as a number.
 * @param {string} str
 * @returns {Maybe<number>}
 */
export const stringToNumberOrNull = (str: string): Maybe<number> => {
    const parsed = parseFloat(str);

    if (Number.isNaN(parsed)) {
        return null;
    }

    return parsed;
};
